import React from "react";
import { Paper, Typography, Grid, Button, Box } from "../../sharedComponent";
import { ReactComponent as CloseIcon } from "../../../assets/xmark-solid.svg";
import SendApproval from "../../../utils/assets/send-approval.png";
import { styled } from "@mui/material/styles";
import useTrans from "../../../hooks/useTranslation";
import { IApproval } from "../../../interfaces/accountForm";

export const BoxStyle = styled(Box)(() => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "10px",
    maxWidth: "80%",
    maxHeight: "70%",
    textAlign: "center",
}));
export const Icon = styled("span")(() => ({
    float: "right",
}));
export const Ptext = styled("p")(() => ({
    margin: "auto",
}));

const SendForApproval = ({
    handleClose,
    handleSendApproval,
    name = "",
}: IApproval) => {
    const [message] = useTrans();

    return (
        <BoxStyle component={Paper} p={9}>
            <div>
                <Icon>
                    <CloseIcon
                        height={25}
                        width={25}
                        fill={"#47474A"}
                        onClick={handleClose}
                        cursor={"pointer"}
                    />
                </Icon>
                <Grid item lg={12}>
                    <img
                        src={SendApproval}
                        width="80px"
                        height="80px"
                        alt="secure-payment"
                    />
                    <Typography variant="h4">
                        {message(
                            "accountForm.modal.approval.sendForApproval.head"
                        )}
                    </Typography>
                    <Ptext>
                        {message(
                            "accountForm.modal.approval.confirmApproval.textOne"
                        )}
                    </Ptext>
                    <Ptext>{`${name} ${message(
                        "accountForm.modal.approval.confirmApproval.textTwo"
                    )}`}</Ptext>
                </Grid>

                <Button
                    name={message("accountForm.modal.approval.cancel")}
                    variant="outlined"
                    color="success"
                    onClick={handleClose}
                    sx={{
                        color: "#84BD00",
                        "&:hover": {
                            color: "white",
                        },
                        backgroundColor: "white",
                        textTransform: "none",
                        margin: "2rem 0.5rem 0rem",
                        width: "43%",
                    }}
                />

                <Button
                    name={message("accountForm.modal.approval.confirm")}
                    variant="contained"
                    color="success"
                    onClick={handleSendApproval}
                    sx={{
                        textTransform: "none",
                        margin: "2rem 0.5rem 0rem",
                        width: "43%",
                    }}
                />
            </div>
        </BoxStyle>
    );
};
export default SendForApproval;
